module.exports = __webpack_public_path__ + "static/img/15kg-min.2512ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weightlifting/15kg-min.png
// module id = Jes+
// module chunks = 1